const SuperAdminPermissions = {
  mainPage: true,
  projectsPage: true,
  batchesPage: true,
  usersPage: true,
  viewImages: true,
  annotate: true,
  addProject: true,
  addBatch: true,
  addUser: true,
  addPermissions: true,
  addImages: true,
  viewBatches: true,
  deleteProjects: true,
  deleteBatches: true,
  export: true,
  import: true,
  editUsers: true,
  showWhizz: true,
  downloadImage: true,
  editFields: true,
};
export default SuperAdminPermissions;
